document.addEventListener(
  "DOMContentLoaded",
  () => {


    const section =
      document.querySelector(
        ".clinical-proof"
      );


    if (!section) return;



    const counters =
      section.querySelectorAll(
        ".clinical-proof__number"
      );



    function animateCounter(element, delay = 0) {


      setTimeout(() => {


        const original =
          element.dataset.number;



        const target =
          parseInt(
            original.replace("%", "")
          );



        let current = 0;



        const duration = 1600;


        const startTime =
          performance.now();




        function update(time){


          const progress =
            Math.min(
              (time - startTime) / duration,
              1
            );



          /*
            Smooth ease-out animation
          */

          const eased =
            1 - Math.pow(
              1 - progress,
              3
            );



          current =
            Math.floor(
              target * eased
            );



          element.textContent =
            current + "%";



          if(progress < 1){

            requestAnimationFrame(
              update
            );

          }
          else {

            element.textContent =
              target + "%";

          }


        }



        requestAnimationFrame(
          update
        );



      }, delay);


    }





    const observer =
      new IntersectionObserver(

        (entries)=>{


          entries.forEach(
            entry=>{


              if(
                entry.isIntersecting
              ){



                counters.forEach(
                  (counter,index)=>{


                    if(
                      !counter.classList.contains(
                        "animated"
                      )
                    ){


                      counter.classList.add(
                        "animated"
                      );


                      /*
                        Small stagger:
                        0ms
                        150ms
                        300ms
                        450ms
                      */

                      animateCounter(
                        counter,
                        index * 150
                      );


                    }


                  }
                );



                observer.disconnect();


              }


            }
          );


        },

        {
          threshold:0.35
        }

      );



    observer.observe(section);



  }
);